import React, { useEffect, useState } from "react"
import GeneralSearch from '../../search/GeneralSearch';
import UserMenu from "./UserMenu";
import FlexRow from "../../base/FlexRow";
import Menu from "../../../core/Menu.json";
import { Link, useLocation } from "react-router-dom";
import { getOwner, hasRoles } from "../../../core/Global";
import Container from "../../base/Container";
import Icon from "../../base/Icon";

function HeaderNavbar() {

  const location = useLocation()
  const [slug, slugSet] = useState<string>()
  const owner = getOwner()

  useEffect(() => {

    const pathSegments = location.pathname.split("/").filter(Boolean);
    if (pathSegments.length > 0) {
      slugSet(pathSegments[0].toLowerCase());
    }

  }, [location.pathname]);


  const AreaHasRole = (area: any) => {
    for (var i = 0; i < area.items?.length; i++) {
      for (var j = 0; j < area.items[i].items?.length; j++) {
        if (hasRoles(area.items[i].items[j].roles)) return true;
      }
      if (area.items[i].roles) {
        if (hasRoles(area.items[i].roles)) return true;
      }
    }
    return false;
  }


  const MenuHasRole = (item: any) => {
    if (item.crm && owner?.freeVoiceAccount) return false;
    if (item.items) {
      for (var j = 0; j < item.items?.length; j++) {
        if (hasRoles(item.items[j].roles)) return true;
      }
    }
    if (item.roles) {
      if (hasRoles(item.roles)) return true;
    }
    return false;
  }



  return (
    <div className="d-flex align-items-center flex-grow-1" id="kt_header_nav">

      <GeneralSearch />
    </div>
  );
}

export default HeaderNavbar;
